module.exports = __webpack_public_path__ + "f5b530eb.png";